

import React from 'react';
import { Form, Input, Spin } from 'antd';

const { TextArea } = Input;

const onFinish = (props, values, form) => {
	const { sendMessageForContact } = props;
	sendMessageForContact(values).then(() => form.resetFields());
};


const ContactUs = (props) => {
	const { loading } = props;
	const [form] = Form.useForm();
	return (
		<div>
			<section className="banner-bg  banner-second contact-banner">
				<div className="container-fluid  ">
					<div className="row d-flex align-items-center ">
						<div className="col-xl-8 col-lg-8 col-md-9 col-sm-12 contact-banner-col"> <img src="/images/contact-banner.jpg" className="img-fluid" alt="" /> </div>
					</div>
				</div>
				<div className="banner-content contact-banner-text">
					<h1>Contact us</h1>
					<p className="">More off this less hello salamander lied porpoise much over tightly circa horse taped so innocuously outside crud mightily rigorous…</p>
					<p className="email-1 mb-0 mt-5">Email at:</p>
					<a className="email-2" href="mailto:info@icause.com.au">info@icause.com.au</a>
					<ul>
						<li><a href="/homepage" title=""><i className="fa fa-pinterest-p"></i></a></li>
						<li><a href="/homepage" title=""><i className="fa fa-twitter"></i></a></li>
						<li><a href="/homepage" title=""><i className="fa fa-facebook"></i></a></li>
					</ul>
				</div>
			</section>
			<section className="choose-a-fundraiser contact-sec-2">
				<div className="container-fluid">
					<div className="row d-flex align-items-center text-center">
						<div className="col-lg-4 col-md-4 col-sm-6 border-rigt banner-bottom">
							<h4>1. Choose a Fundraiser</h4>
							<p>Browse our fundraising ideas for inspiration</p>
						</div>
						<div className="col-lg-4 col-md-4 col-sm-6 border-rigt banner-bottom">
							<h4>2. Create a Campaign</h4>
							<p>Simply sign up with your email or facebook to get started</p>
						</div>
						<div className="col-lg-4 col-md-4 col-sm-6 banner-bottom">
							<h4>3. Invite your Friends</h4>
							<p>Send out your unique link to start receving donations</p>
						</div>
					</div>
				</div>
			</section>
			<section className="who-need contact-sec-3 pb-0">
				<div className="container">
					<div className="row">
						<div className="col-md-10 mx-auto contact-sec-3-text">
							<h5 className="text-grn ">A help to those who need it</h5>
							<h3 className="main-heading   mt-md-0">Each Donation is Very Essential</h3>
						</div>
					</div>
					<div className="col-12">
						<iframe
							title='dsa'
							width="100%"
							height="500"
							src="https://www.youtube.com/embed/j7KKZ6v5o34"
							frameBorder="0"
							allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
							allowFullScreen>
						</iframe>
					</div>
					<div className="row">
						<div className="col-md-10 mx-auto py-5 contact-sec-3-text" >
							<p>We know that with the best of intentions, it’s not always possible to give as much as you’d like. That’s why we’ve created a unique way to donate. Not only can you donate directly to your chosen cause, but you can also choose to use your utility bill to donate – it’s easy to do and you might make a saving for yourself in the process. Find out how you can donate with your bill here.</p>
							<p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English. Many desktop publishing packages and web page editors now use Lorem Ipsum as their default model.</p>
							<p>Text, and a search for 'lorem ipsum' will uncover many web sites still in their infancy.<br></br> Various versions have evolved over the years, sometimes by accident,<br></br> sometimes on purpose (injected humour and the like).</p>
						</div>
					</div>
				</div>
			</section>
			<section className="honestly contact-sec-4">
				<div className="container">
					<div className="row">
						<div className="col-lg-11 mx-auto">
							<div className="row  ">
								<div className="col-lg-4 col-md-3 col-sm-4 mx-auto">
									<img src="/images/contact-sec-4-img-1.png" className="img-fluid w-100" alt="" />
								</div>
								<div className="col-lg-8 col-md-9 d-flex align-items-center">
									<div className="honestly-content text-box">
										<h5>Helped out Worldwide with iCause</h5>
										<h3 className="main-heading  mb-0 mt-md-0 text-white">Honestly, iCause Saved  myBrother Life !</h3>
										<p className="text-white mt-3">Australia has shown over and over again that we’re a giving nation; from supporting   a local club to inspiring global change, we know that it all starts with the first step. We’ve created iCause to give every Australian the chance to help.</p>
										<ul>
											<li><p>164 <span>Participants</span></p></li>
											<li><p>29k<span>Money Collected</span></p></li>
											<li><p>30k<span>Our Goal</span></p></li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<section className="drop-line py-5 contact-sec-5">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="drop-title d-flex justify-content-between flex-wrap align-items-center mb-3">
								<div className="left-title">
									<h5 className="border-left mb-0">We are here for your help</h5>
									<h3 className="main-heading   mt-md-0">Drop us a line...</h3>
								</div>
								<div className="right-title">
									<h6 className="mb-0">Email us at</h6>
									<h5 className="main-heading   mt-md-0">info@icause.com</h5>
								</div>
							</div>
							<Spin spinning={loading}>
								<Form
									form={form}
									layout="vertical"
									name="basic"
									onFinish={(values) => onFinish(props, values, form)}
								>
									<div className="form-group">
										<label>Type your name</label>
										<Form.Item
											name="name"
											rules={[
												{
													required: true,
													message: 'Please input your name !',
												},
											]}>
											<Input type="text" className="form-control" placeholder="e.g. Mark" />
										</Form.Item>
									</div>
									<div className="form-group">
										<label>Type your email</label>
										<Form.Item
											name="email"
											rules={[
												{
													required: true,
													message: 'Please input your email !',
												},
											]}>
											<Input type="email" className="form-control" placeholder="e.g. markcarson@gmail.com" />
										</Form.Item>
									</div>
									<div className="form-group">
										<label>Type your Message</label>
										<Form.Item
											name="body"
											rules={[
												{
													required: true,
													message: 'Please input your message!',
												},
											]}>
											<TextArea className="form-control" rows={4} />
										</Form.Item>
									</div>
									<button
										htmltype='submit'
										className="btn btn-outline-dark">
										SEND NOW
									</button>
								</Form>
							</Spin>
						</div>
					</div>
					<div className="row">
						<div className="col-md-10 mx-auto py-5 contact-sec-5-text" >
							<p>We know that with the best of intentions, it’s not always possible to give as much as you’d like. That’s why we’ve created a unique way to donate. Not only can you donate directly to your chosen cause, but you can also choose to use your utility bill to donate – it’s easy to do and you might make a saving for yourself in the process. Find out how you can donate with your bill here.</p>
							<p>You will know that chat is available at the time you’re contacting us if you see both of the options shown above. If you do not see the option to click “Chat Now”, please either email our team or check back after one hour to see if chat is available.</p>
							<p>Please keep in mind, the GoFundMe Help Center is filled with several articles that may have the answer you are looking for. Before contacting our team, please use the search bar at the top of the page and search for keywords that are related to your question. Here are some examples:</p>
							<ul className="list-circal">
								<li><i className="fa fa-circle mr-2 "></i>"Where are my donations?" - Keywords: Missing donations.</li>
								<li><i className="fa fa-circle mr-2 "></i>"How can I remove my name from my donation?" - Keywords: Anonymous donation.</li>
								<li><i className="fa fa-circle mr-2 "></i>"I need a refund" - Keywords: Refunds.</li>
								<li><i className="fa fa-circle mr-2 "></i>"How do I close my GoFundMe fundraiser?" - Keywords: Deactivate fundraiser.</li>
							</ul>
						</div>
					</div>
				</div>
			</section>
			<section className="faq-contact contact-sec-6">
				<div className="container">
					<div className="row">
						<div className="col-lg-10 mx-auto">
							<div className="row">
								<div className="col-12">
									<div className="top-text">
										<h5>General Inquiries</h5>
										<h3>FAQ's</h3>
									</div>
								</div>
							</div>
							<div id="accordion" className="myaccordion faq-wrap">
								<div className="card">
									<div className="card-header">
										<h2 className="mb-0">
											<button className="d-flex align-items-center justify-content-between btn btn-link collapsed" data-toggle="collapse" data-target="#faq-1" aria-expanded="false" aria-controls="faq-1">
												<p>How to Transfer Donation with Utility Bill Payment</p>
												<span><i className="fa fa-minus fa-stack-1x fa-inverse"></i></span>
											</button>
										</h2>
									</div>
									<div id="faq-1" className="collapse" data-parent="#accordion">
										<div className="card-body">
											<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
										</div>
									</div>
								</div>

								<div className="card">
									<div className="card-header">
										<h2 className="mb-0">
											<button className="d-flex align-items-center justify-content-between btn btn-link collapsed" data-toggle="collapse" data-target="#faq-2" aria-expanded="false" aria-controls="faq-2">
												<p>Center is filled with several articles that..</p>
												<span><i className="fa fa-minus fa-stack-1x fa-inverse"></i></span>
											</button>
										</h2>
									</div>
									<div id="faq-2" className="collapse" data-parent="#accordion">
										<div className="card-body">
											<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
										</div>
									</div>
								</div>

								<div className="card">
									<div className="card-header">
										<h2 className="mb-0">
											<button className="d-flex align-items-center justify-content-between btn btn-link collapsed" data-toggle="collapse" data-target="#faq-3" aria-expanded="false" aria-controls="faq-3">
												<p>Where are my donations? Keywords: Missing ..</p>
												<span><i className="fa fa-minus fa-stack-1x fa-inverse"></i></span>
											</button>
										</h2>
									</div>
									<div id="faq-3" className="collapse" data-parent="#accordion">
										<div className="card-body">
											<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
										</div>
									</div>
								</div>

								<div className="card">
									<div className="card-header">
										<h2 className="mb-0">
											<button className="d-flex align-items-center justify-content-between btn btn-link collapsed" data-toggle="collapse" data-target="#faq-4" aria-expanded="false" aria-controls="faq-4">
												<p>Which currency of type iCause accept...</p>
												<span><i className="fa fa-minus fa-stack-1x fa-inverse"></i></span>
											</button>
										</h2>
									</div>
									<div id="faq-4" className="collapse" data-parent="#accordion">
										<div className="card-body">
											<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
										</div>
									</div>
								</div>

								<div className="card">
									<div className="card-header">
										<h2 className="mb-0">
											<button className="d-flex align-items-center justify-content-between btn btn-link collapsed" data-toggle="collapse" data-target="#faq-5" aria-expanded="false" aria-controls="faq-5">
												<p>iCause I need a refund.</p>
												<span><i className="fa fa-minus fa-stack-1x fa-inverse"></i></span>
											</button>
										</h2>
									</div>
									<div id="faq-5" className="collapse" data-parent="#accordion">
										<div className="card-body">
											<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
										</div>
									</div>
								</div>

								<div className="card">
									<div className="card-header">
										<h2 className="mb-0">
											<button className="d-flex align-items-center justify-content-between btn btn-link collapsed" data-toggle="collapse" data-target="#faq-6" aria-expanded="false" aria-controls="faq-6">
												<p>I need a refund - Keywords: Refunds.</p>
												<span><i className="fa fa-minus fa-stack-1x fa-inverse"></i></span>
											</button>
										</h2>
									</div>
									<div id="faq-6" className="collapse" data-parent="#accordion">
										<div className="card-body">
											<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum</p>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section className="contact-sec-7">
				<div className="container">
					<div className="row">
						<div className="col-lg-11 mx-auto">
							<div className="img-wrap">
								<div>
									<img src="/images/contact-6-img-6.png" className="img-fluid" alt="img" />
								</div>
								<div>
									<img src="/images/contact-6-img-1.png" className="img-fluid" alt="img" />
								</div>
								<div>
									<img src="/images/contact-6-img-2.png" className="img-fluid" alt="img" />
								</div>
								<div>
									<img src="/images/contact-6-img-3.png" className="img-fluid" alt="img" />
								</div>
								<div>
									<img src="/images/contact-6-img-4.png" className="img-fluid" alt="img" />
								</div>
								<div>
									<img src="/images/contact-6-img-5.png" className="img-fluid" alt="img" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
		</div>
	);
};

export default ContactUs;
